import React from 'react';

type IconProps = {
  size?: number;
};

const Svg = ({size = 19, children}: IconProps & {children: React.ReactNode}) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    {children}
  </svg>
);

export const OverviewIcon = (props: IconProps) => (
  <Svg {...props}>
    <path d="M3 3h7v7H3zm9 0h9v5h-9zm0 7h9v11h-9zM3 12h7v9H3z" />
  </Svg>
);

export const EventsIcon = (props: IconProps) => (
  <Svg {...props}>
    <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zM7 11h5v5H7z" />
  </Svg>
);

export const EntriesIcon = (props: IconProps) => (
  <Svg {...props}>
    <path d="M14.5 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM11 7l-4 4 1.4 1.4 2.6-2.6V13l-5 5 1.4 1.4 5.6-5.6V10l2 2h4v-2h-3l-3-3h-2zM4 3h5v2H4zm-1 4h4v2H3zm12 9 3-3 1.4 1.4-3 3zM3 21l4-1-3-3z" />
  </Svg>
);

export const DevicesIcon = (props: IconProps) => (
  <Svg {...props}>
    <path d="M2 11 22 2l-9 20-2-9z" />
  </Svg>
);

export const UsersIcon = (props: IconProps) => (
  <Svg {...props}>
    <path d="M16 11c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3zM8 11c1.7 0 3-1.3 3-3S9.7 5 8 5 5 6.3 5 8s1.3 3 3 3zm0 2c-2.3 0-7 1.2-7 3.5V19h14v-2.5C15 14.2 10.3 13 8 13zm8 0c-.3 0-.7 0-1 .1 1.2.8 2 1.9 2 3.4V19h6v-2.5c0-2.3-4.7-3.5-7-3.5z" />
  </Svg>
);

export const LogsIcon = (props: IconProps) => (
  <Svg {...props}>
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-2h2zm0-4h-2V7h2z" />
  </Svg>
);

export const RolesIcon = (props: IconProps) => (
  <Svg {...props}>
    <path d="M12 2 3 6v6c0 5.5 9 10 9 10s9-4.5 9-10V6zm0 18V4l7 3v5c0 3.3-4.6 6.6-7 8z" />
  </Svg>
);

export const SettingsIcon = (props: IconProps) => (
  <Svg {...props}>
    <path d="m19.4 13 .1-1-.1-1 2.1-1.6-2-3.5-2.5 1a8 8 0 0 0-1.7-1L15 3h-4l-.4 2.9-1.7 1-2.5-1-2 3.5L6.5 11l-.1 1 .1 1-2.1 1.6 2 3.5 2.5-1 1.7 1L11 21h4l.4-2.9 1.7-1 2.5 1 2-3.5zM13 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" />
  </Svg>
);

export const AllDevicesIcon = (props: IconProps) => (
  <Svg {...props}>
    <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4v10h10V6H7zm5 14a1.2 1.2 0 1 0 0-2.4A1.2 1.2 0 0 0 12 20z" />
  </Svg>
);

const icons = {
  overview: OverviewIcon,
  events: EventsIcon,
  entries: EntriesIcon,
  devices: DevicesIcon,
  users: UsersIcon,
  logs: LogsIcon,
  roles: RolesIcon,
  settings: SettingsIcon,
  allDevices: AllDevicesIcon
};

export type NavIconName = keyof typeof icons;

export const NavIcon = ({name, size}: {name: NavIconName; size?: number}) => {
  const Icon = icons[name];
  return <Icon size={size} />;
};
